// @flow weak

import _ from 'lodash/fp';
import {combineReducers} from 'redux';
import {
  REQUEST, SUCCESS,
  FAILURE, FILTER,
  SORT,
} from '../actions/productTypeList';

const error = (state = null, action) => {
  switch (action.type) {
    case REQUEST:
    case SUCCESS:
      return null;
    case FAILURE:
      return action.error;
    default:
      return state;
  }
};

const archived = (state = false, action) => {
  switch (action.type) {
    case FILTER:
      return action.archived;
    default:
      return state;
  }
};

const query = (state = null, action) => {
  switch (action.type) {
    case FILTER:
      return action.query;
    default:
      return state;
  }
};

const filter = combineReducers({
  archived,
  query,
});

const isFetching = (state = false, action) => {
  switch (action.type) {
    case REQUEST:
      return true;
    case SUCCESS:
    case FAILURE:
      return false;
    default:
      return state;
  }
};

const list = (state = [], action) => {
  switch (action.type) {
    case SUCCESS:
      return action.productTypes;
    default:
      return state;
  }
};

const isArchived =
  _.filter(t => _.isString(t.archived));

const notArchived =
  _.filter({archived: null});

const filteredList = ({
  filter: {archived},
  list,
  filteredList: filtered,
  sorter,
} = {}, action) => {
  switch (action.type) {
    case SUCCESS:
    case FILTER:
    case SORT:
      return _.flow(
        archived
          ? isArchived
          : notArchived,
        sorter
      )(list);
    default:
      return filtered;
  }
};

const sorter = (state = _.identity, action) => {
  switch (action.type) {
    case SORT:
      return action.sorter;
    default:
      return state;
  }
};

const reducers = combineReducers({
  filteredList: (state = []) => state,
  error,
  filter,
  isFetching,
  list,
  sorter,
});

const productTypeList = (state, action) => {
  const newState = reducers(state, action);
  return {
    ...newState,
    filteredList: filteredList(newState, action),
  };
};

export default productTypeList;



// WEBPACK FOOTER //
// ./src/reducers/productTypeList.js